module.exports = __webpack_public_path__ + "static/media/35.87f4e128.png";